import UniversalRouter from "universal-router";

import { asyncRouteAction, Routes } from "./lib/routing";
import Root from "./common/Root";
import companiesRoutes from "./companies/routes";

const routes: Routes = {
  path: "/",
  async action(context, params) {
    const children = await context.next();
    return {
      component: Root,
      path: context.path,
      query: context.query,
      children,
      params,
    };
  },
  children: [
    {
      path: "/companies/:companyId/employee_interviews/:postId",
      action: asyncRouteAction({
        loader: () =>
          import(/* webpackChunkName: "post_article_ShowContainer" */ "./post_articles/components/ShowContainer"),
      }),
    },
    {
      path: "/companies/:companyId/post_articles/:postId",
      action: asyncRouteAction({
        loader: () =>
          import(/* webpackChunkName: "post_article_ShowContainer" */ "./post_articles/components/ShowContainer"),
      }),
    },
    {
      path: "/companies/:companyId",
      action: asyncRouteAction({
        loader: () => import(/* webpackChunkName: "companies_RootContainer" */ "./companies/components/RootContainer"),
      }),
      children: companiesRoutes,
    },
    {
      path: "/values",
      action: asyncRouteAction({
        loader: () =>
          import(/* webpackChunkName: "company_values_RootContainer" */ "./company_values/components/RootContainer"),
      }),
    },
  ],
};

export default routes;
export const router = new UniversalRouter(routes, {
  resolveRoute(context, params) {
    return context.route.action!(context, params);
  },
});



// WEBPACK FOOTER //
// ./frontend/src/routes.tsx